import { ROUTES_APPLICATION_PATH } from "../../../../routes.constants";

import { buildMenu, SECTION_LABELS } from './utils'

export const FASHION_RETAIL_ITEMS = {
  productOpportunities: (t) => ({
    pageName: "Oportunidades",
    route: ROUTES_APPLICATION_PATH.OPPORTUNITIES.COMPONENT_URL[0],
    icon: "lightbulb",
  }),
  opportunitiesCheckout: (t) => ({
    pageName: "Checkout de Oportunidades",
    route: ROUTES_APPLICATION_PATH.OPPORTUNITIES.COMPONENT_URL[1],
    icon: "lightbulb",
  }),
  opportunitiesDetailed: (t) => ({
    pageName: "Oportunidades",
    route: ROUTES_APPLICATION_PATH.OPPORTUNITIES.COMPONENT_URL[2],
    icon: "lightbulb",
  }),
  planoProduto: (t) => ({
    pageName: "Plano Produto",
    route: ROUTES_APPLICATION_PATH.ANALYSIS.COMPONENT_URL[0],
    icon: "sitemap",
  }),
  otb: (t) => ({
    pageName: "OTB",
    route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[5],
    icon: "box",
  }),
  planoCompra: (t) => ({
    pageName: "Plano de Compra",
    route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[4],
    icon: "cart",
  }),
  planejamento: (t) => ({
    pageName: "Planejamento",
    route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[3],
    icon: "sitemap",
  }),  
  qualidadeEstoque: (t) => ({
    pageName: "Qualidade de Estoque",
    route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[2],
    icon: "shield",
  }),  
};

export const getFashionRetailNavigationOptions = (t, tenantContext, config = {}, options = {}) => {
  const {
    hasProductOpportunities = false,
    hasOpportunityCheckout = false,
    hasPlanvsforecastAnalysis = false,
  } = tenantContext;

  const {
    opportunityItems = [
      hasProductOpportunities && FASHION_RETAIL_ITEMS.opportunitiesDetailed(t),
      hasOpportunityCheckout && FASHION_RETAIL_ITEMS.opportunitiesCheckout(t),
    ],
    hasOtb = true,
    hasPurchasePlan = true,
    hasPlanning = true,
    hasInventoryQuality = true,
    transactionalItems = [
      hasOtb && FASHION_RETAIL_ITEMS.otb(t),
      hasPurchasePlan && FASHION_RETAIL_ITEMS.planoCompra(t),
      hasPlanning && FASHION_RETAIL_ITEMS.planejamento(t),
      hasInventoryQuality && FASHION_RETAIL_ITEMS.qualidadeEstoque(t),
    ],
    dataItems = [],
    hasOwnHome = true
  } = config;

  const home = hasOwnHome && {
    menuName: "Home",
    route: ROUTES_APPLICATION_PATH.HOME.BASE_URL,
    icon: "home",
  };

  const plano = buildMenu({
    menuName: "Plano",
    route: ROUTES_APPLICATION_PATH.ANALYSIS.BASE_URL,
    icon: "plano",
    sectionDefs: [
      { label: SECTION_LABELS.OPPORTUNITIES, items: [] },
      {
        label: SECTION_LABELS.TRANSACTIONAL,
        items: [
          hasPlanvsforecastAnalysis && FASHION_RETAIL_ITEMS.planoProduto(t),
        ],
      },
      { label: SECTION_LABELS.DATA, items: [] },
    ],
    options
  });

  const produto = buildMenu({
    menuName: "Produto",
    route: ROUTES_APPLICATION_PATH.PRODUCTS.BASE_URL,
    icon: "produto",
    sectionDefs: [
      {
        label: SECTION_LABELS.OPPORTUNITIES,
        items: opportunityItems,
      },
      {
        label: SECTION_LABELS.TRANSACTIONAL,
        items: transactionalItems,
      },
      {
        label: SECTION_LABELS.DATA,
        items: dataItems,
      },
    ],
    options
  });

  return [home, plano, produto].filter(Boolean);
};